const tabs = [
    {
        name: "For You",
        href: "/",
        key: "/",
    },
    {
        name: "Following",
        href: "/following",
        key: "Following",
    },
    {
        name: "Relationships",
        href: "/category/relationships",
        key: "Relationships",
    },
    {
        name: "Entertainment",
        href: "/category/entertainment",
        key: "Entertainment",
    },
    {
        name: "News",
        href: "/category/news",
        key: "News",
    },
    {
        name: "Health",
        href: "/category/health",
        key: "Health",
    },
    {
        name: "Travel",
        href: "/category/travel",
        key: "Travel",
    },
    {
        name: "Food",
        href: "/category/food",
        key: "Food",
    },
    {
        name: "Pets",
        href: "/category/pets",
        key: "Pets",
     
    },
];
module.exports = tabs;